import axios from 'axios'

const WithdrawalService = {
  async get (params = {}) {
    return axios.get('lo/withdrawal/requests', { params })
  },

  async histories (params = {}) {
    return axios.get('lo/reports/withdrawal/request-histories', { params })
  },

  async show (id) {
    return axios.get(`lo/withdrawal/requests/${id}`)
  },

  async post (params = {}) {
    return axios.post('lo/withdrawal/requests', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`lo/withdrawal/requests/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`lo/withdrawal/requests/${data.id}`, { data })
  }
}

export default WithdrawalService
